import { useCallback, useEffect, useRef } from 'react';

import { Progress } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

import GapEvent from './GapEvent';
import { useWeekViewCalendarDay } from './useWeekViewCalendarDay';
import WeekViewEvent from './WeekViewEvent';

interface Props {
  day: Date;
  first: boolean;
}

const weekColWidth = 100 / 7;

const styles = {
  dayColumnFirst: {
    fontSize: fonts.sm,
    padding: '0.25rem',
    width: `${weekColWidth}%`,
    overflowY: 'auto',
    height: '80vh',
  },
};

const WeekViewDay = ({ day, first }: Props) => {
  const { workOrderDay, paginateDay } = useWeekViewCalendarDay(day);
  const scrollContainerRef = useRef<any>(null);

  const dayColumnStyle = {
    ...styles.dayColumnFirst,
    borderLeft: `1px solid ${colors.neutral.ash}`,
  };

  const handleScroll = useCallback(() => {
    const elem = scrollContainerRef?.current;
    const isBottom =
      elem?.scrollTop + elem?.clientHeight + 0.5 >= elem?.scrollHeight;
    if (isBottom) {
      paginateDay();
    }
  }, [scrollContainerRef.current, paginateDay]);

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef?.current?.addEventListener('scroll', handleScroll);
      return () =>
        scrollContainerRef?.current?.removeEventListener(
          'scroll',
          handleScroll,
        );
    }
    return () => {};
  }, [handleScroll]);

  return (
    <div
      ref={scrollContainerRef}
      // @ts-ignore
      style={first ? styles.dayColumnFirst : dayColumnStyle}
    >
      {workOrderDay!! ? (
        workOrderDay.map((event, eventIdx) => {
          return event.isGap ? (
            <GapEvent
              key={eventIdx}
              event={event}
              last={eventIdx === workOrderDay.length - 1}
            />
          ) : (
            <WeekViewEvent key={eventIdx} workOrder={event} />
          );
        })
      ) : (
        <Progress size={20} />
      )}
    </div>
  );
};

export default WeekViewDay;
